import { forwardRef } from 'react';
import TextareaAutosize from 'react-textarea-autosize';

export const Textarea = forwardRef((props, ref) => {
  return (
    <div>
      {props.label && (
        <div style={{ textAlign: 'left', fontSize: 14, color: '#888', marginBottom: 5 }}>{props.label}</div>
      )}
      <TextareaAutosize
        {...props}
        ref={ref}
        style={{
          border: '1px solid #ccc',
          padding: '6px 10px',
          borderRadius: 5,
          resize: 'none',
          fontSize: 14,
          fontFamily: 'helvetica',
          ...props.style,
        }}
      />
    </div>
  );
});
